import { atom } from "jotai";

export const modalAtom = atom<null | string>(null);
export const modalDataAtom = atom<null | string | number | boolean | object>(null);
